import React from 'react';
import GavelRoundedIcon from '@mui/icons-material/GavelRounded';
import SecurityRoundedIcon from '@mui/icons-material/SecurityRounded';
import PaymentRoundedIcon from '@mui/icons-material/PaymentRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import InfoPageLayout from './components/InfoPageLayout';
import InfoSection from './components/InfoSection';
import './InfoPage.scss';

const Terms = () => (
    <InfoPageLayout
        eyebrow="Legal"
        title="Terms & Conditions"
        subtitle="Please read these terms carefully. By using Khaata POS, you agree to the guidelines below."
    >
        <InfoSection icon={<GavelRoundedIcon />} title="Agreement overview">
            <p>
                By accessing and using Khaata POS, you agree to comply with and be bound by these terms and conditions.
                These terms apply to all users of the system, including but not limited to restaurant owners, managers,
                staff members, and administrators.
            </p>
        </InfoSection>

        <InfoSection icon={<SecurityRoundedIcon />} title="Data security & privacy">
            <ul className="info-list">
                <li className="info-list__item">
                    <span className="info-list__label">Data protection</span>
                    <p className="info-list__text">
                        We implement industry-standard security measures to protect your business and customer data.
                    </p>
                </li>
                <li className="info-list__item">
                    <span className="info-list__label">Data usage</span>
                    <p className="info-list__text">
                        Your data will only be used for providing and improving our services. We do not sell or share your data with third parties.
                    </p>
                </li>
                <li className="info-list__item">
                    <span className="info-list__label">Compliance</span>
                    <p className="info-list__text">
                        Our system complies with relevant data protection regulations and industry standards.
                    </p>
                </li>
            </ul>
        </InfoSection>

        <InfoSection icon={<PaymentRoundedIcon />} title="Billing & payments">
            <ul className="info-list">
                <li className="info-list__item">
                    <span className="info-list__label">Subscription terms</span>
                    <p className="info-list__text">
                        Payment is required in advance for all subscription periods. Prices are subject to change with 30 days notice.
                    </p>
                </li>
                <li className="info-list__item">
                    <span className="info-list__label">Refund policy</span>
                    <p className="info-list__text">
                        Refunds are processed on a case-by-case basis. Please contact our support team for assistance.
                    </p>
                </li>
            </ul>
        </InfoSection>

        <InfoSection icon={<SupportAgentRoundedIcon />} title="Support & maintenance" lastUpdated="February 2024">
            <p>
                We provide 24/7 technical support for all subscription tiers. System maintenance and updates
                are performed during off-peak hours to minimize disruption to your business operations.
            </p>
        </InfoSection>
    </InfoPageLayout>
);

export default Terms;
